var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAliviaANoCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 46,
    viewBox: "0 0 59 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_289_1312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0766 33.5616L24.4269 19.7984L28.5847 27.8208L17.0766 33.5616ZM47.3689 27.7472L49.2251 31.28L58.1346 17.664L41.8005 16.8544L43.6566 20.3872L36.9745 23.6992L24.5754 0L0 46H10.7657L32.297 35.1808L37.8654 46H48.3341L40.6125 31.1328L47.3689 27.7472Z",
    fill: "#11C0F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_289_1312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAliviaANoCircle);
export default __webpack_public_path__ + "static/media/AliviaA_noCircle.856b80f9bdf0896cc444fe0a0c392670.svg";
export { ForwardRef as ReactComponent };